import { useMemo } from 'react';
import { Redirect, Route, RouteProps } from 'react-router';
import { PermissionUtil } from './framework/commons/PermissionUtil';
import { LocalStorage } from './framework/commons/LocalStorage';
import { LoginStore } from './framework/store/LoginStore';

type PrivateRouteProps = {
  permissions: string[]
} & RouteProps;

export default function PrivateRoute({ permissions, ...routeProps }: PrivateRouteProps) {
  const userPermissions = LoginStore.getPermission()
  
  const allowed = useMemo(() => {
    return permissions.some(permission => PermissionUtil.can(permission, userPermissions || []))
  }, [permissions, userPermissions])

  const usuarioIntelbras = (email: string) => {
    if (/@intelbras.com.br\s*$/.test(email)) {
      return true;
    }
    return false;
  }

  let pathname = "/";

  const userInfo = LocalStorage.get("solar.userExtraInfo", true);
  const usuarioInterno = usuarioIntelbras(userInfo?.email);
  if(userInfo){
    if(!userInfo?.isDistribuidor && !usuarioInterno && !userInfo?.distribuidor_cnpj_cpf){
      pathname = "/associar_distribuidor";
    }
  }

  if (!userPermissions.length) {
    return null;
  }

  if (allowed === undefined) return <div />

  if(allowed && pathname !== "/associar_distribuidor") {
    return <Route {...routeProps} />;
  } else {
    return <Redirect to={{ pathname }} />;
  }
}